import React from 'react';

// Mobile/App Icon
export const MobileIcon = ({ className = "", size = 20 }) => (
  <svg 
    className={className}
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="currentColor"
  >
    <path d="M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"/>
  </svg>
);

// Design/Creative Icon
export const DesignIcon = ({ className = "", size = 20 }) => (
  <svg 
    className={className}
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="currentColor"
  >
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
  </svg>
);

// AI/Robot Icon
export const AIIcon = ({ className = "", size = 20 }) => (
  <svg 
    className={className}
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="currentColor"
  >
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
    <circle cx="9" cy="9" r="1"/>
    <circle cx="15" cy="9" r="1"/>
  </svg>
);

// Lightning/Speed Icon
export const LightningIcon = ({ className = "", size = 20 }) => (
  <svg 
    className={className}
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="currentColor"
  >
    <path d="M7 2v11h3v9l7-12h-4l4-8z"/>
  </svg>
);

// Shopping/E-commerce Icon
export const ShoppingIcon = ({ className = "", size = 20 }) => (
  <svg 
    className={className}
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="currentColor"
  >
    <path d="M7 4V2C7 1.45 7.45 1 8 1h8c.55 0 1 .45 1 1v2h4c.55 0 1 .45 1 1s-.45 1-1 1h-1v14c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2V6H3c-.55 0-1-.45-1-1s.45-1 1-1h4zm2 0h6V3H9v1z"/>
  </svg>
);

// Recycle/Sustainability Icon
export const RecycleIcon = ({ className = "", size = 20 }) => (
  <svg 
    className={className}
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="currentColor"
  >
    <path d="M6.89 8.11L8.3 9.52 3.83 14 8.3 18.48 6.89 19.89 1 14 6.89 8.11zm8.22 0L23 14l-5.89 5.89-1.41-1.41L18.17 14 14.7 9.52 16.11 8.11zM12 6.5c-3.03 0-5.5 2.47-5.5 5.5s2.47 5.5 5.5 5.5 5.5-2.47 5.5-5.5-2.47-5.5-5.5-5.5zm0 9c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"/>
  </svg>
);

// Food/Recipe Icon
export const RecipeIcon = ({ className = "", size = 20 }) => (
  <svg 
    className={className}
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="currentColor"
  >
    <path d="M8.1 13.34l2.83-2.83L3.91 3.5c-1.56 1.56-1.56 4.09 0 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z"/>
  </svg>
);

// Article/Text Icon
export const ArticleIcon = ({ className = "", size = 20 }) => (
  <svg 
    className={className}
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="currentColor"
  >
    <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
  </svg>
);

// Banking/Finance Icon
export const BankingIcon = ({ className = "", size = 20 }) => (
  <svg 
    className={className}
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="currentColor"
  >
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
    <path d="M5 18h14v2H5zM7 14h10l-1-6H8l-1 6z"/>
  </svg>
);

// Insights/Bulb Icon
export const InsightsIcon = ({ className = "", size = 20 }) => (
  <svg 
    className={className}
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="currentColor"
  >
    <path d="M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7zm2.85 11.1l-.85.6V16h-4v-2.3l-.85-.6C7.8 12.16 7 10.63 7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.63-.8 3.16-2.15 4.1z"/>
  </svg>
);

// Solution/Checkmark Icon
export const SolutionIcon = ({ className = "", size = 20 }) => (
  <svg 
    className={className}
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="currentColor"
  >
    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
  </svg>
);

// Learning/Book Icon
export const LearningIcon = ({ className = "", size = 20 }) => (
  <svg 
    className={className}
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="currentColor"
  >
    <path d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z"/>
  </svg>
);

// Goal/Target Icon
export const GoalIcon = ({ className = "", size = 20 }) => (
  <svg 
    className={className}
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="currentColor"
  >
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
  </svg>
);

// Team/People Icon
export const TeamIcon = ({ className = "", size = 20 }) => (
  <svg 
    className={className}
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="currentColor"
  >
    <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
  </svg>
);

// Briefcase/Work Icon
export const BriefcaseIcon = ({ className = "", size = 20 }) => (
  <svg 
    className={className}
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="currentColor"
  >
    <path d="M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z"/>
  </svg>
);

// Mentor/Graduation Icon
export const MentorIcon = ({ className = "", size = 20 }) => (
  <svg 
    className={className}
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="currentColor"
  >
    <path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z"/>
  </svg>
);

// Blockchain/Web3 Icon
export const BlockchainIcon = ({ className = "", size = 20 }) => (
  <svg 
    className={className}
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="currentColor"
  >
    <path d="M12 2L4 7v10l8 5 8-5V7l-8-5zm6 13.5l-6 3.75-6-3.75V8.5l6-3.75 6 3.75v7z"/>
    <circle cx="12" cy="12" r="2"/>
    <path d="M12 7v3M12 14v3M7 9.5l2.5 1.5M14.5 13l2.5 1.5M7 14.5l2.5-1.5M14.5 11l2.5-1.5"/>
  </svg>
);

// Security/Lock Icon
export const SecurityIcon = ({ className = "", size = 20 }) => (
  <svg 
    className={className}
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="currentColor"
  >
    <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/>
  </svg>
);

// Target/Focus Icon
export const TargetFocusIcon = ({ className = "", size = 20 }) => (
  <svg 
    className={className}
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="currentColor"
  >
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
    <circle cx="12" cy="12" r="3"/>
  </svg>
);

// Globe/World Icon
export const GlobeIcon = ({ className = "", size = 20 }) => (
  <svg 
    className={className}
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="currentColor"
  >
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
  </svg>
);

// Eye/Visibility Icon
export const EyeIcon = ({ className = "", size = 20 }) => (
  <svg 
    className={className}
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="currentColor"
  >
    <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
  </svg>
);

// Community/Group Icon
export const CommunityIcon = ({ className = "", size = 20 }) => (
  <svg 
    className={className}
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="currentColor"
  >
    <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
  </svg>
);

// Dashboard/Chart Icon
export const DashboardIcon = ({ className = "", size = 20 }) => (
  <svg 
    className={className}
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="currentColor"
  >
    <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"/>
  </svg>
);

// Signal/Network Icon
export const SignalIcon = ({ className = "", size = 20 }) => (
  <svg 
    className={className}
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="currentColor"
  >
    <path d="M1 9l2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9zm8 8l3 3 3-3c-1.65-1.66-4.34-1.66-6 0zm-4-4l2 2c2.76-2.76 7.24-2.76 10 0l2-2C15.14 9.14 8.87 9.14 5 13z"/>
  </svg>
);

// Shield/Protection Icon
export const ShieldIcon = ({ className = "", size = 20 }) => (
  <svg 
    className={className}
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="currentColor"
  >
    <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/>
  </svg>
);

// Building/Organization Icon
export const BuildingIcon = ({ className = "", size = 20 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"/>
  </svg>
);

// ============== SOCIAL ICONS ==============

// Facebook Icon
export const FacebookIcon = ({ className = "", size = 24 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

// Twitter/X Icon
export const TwitterIcon = ({ className = "", size = 24 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
);

// Dribbble Icon
export const DribbbleIcon = ({ className = "", size = 24 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M12 24C5.385 24 0 18.615 0 12S5.385 0 12 0s12 5.385 12 12-5.385 12-12 12zm10.12-10.358c-.35-.11-3.17-.953-6.384-.438 1.34 3.684 1.887 6.684 1.992 7.308 2.3-1.555 3.936-4.02 4.395-6.87zm-6.115 7.808c-.153-.9-.75-4.032-2.19-7.77l-.066.02c-5.79 2.015-7.86 6.025-8.04 6.4 1.73 1.358 3.92 2.166 6.29 2.166 1.42 0 2.77-.29 4-.818zm-11.62-2.58c.232-.4 3.045-5.055 8.332-6.765.135-.045.27-.084.405-.12-.26-.585-.54-1.167-.832-1.74C7.17 11.775 2.206 11.71 1.756 11.7l-.004.312c0 2.633.998 5.037 2.634 6.855zm-2.42-8.955c.46.008 4.683.026 9.477-1.248-1.698-3.018-3.53-5.558-3.8-5.928-2.868 1.35-5.01 3.99-5.676 7.17zM9.6 2.052c.282.38 2.145 2.914 3.822 6 3.645-1.365 5.19-3.44 5.373-3.702-1.81-1.61-4.19-2.586-6.795-2.586-.825 0-1.63.1-2.4.285zm10.335 3.483c-.218.29-1.935 2.493-5.724 4.04.24.49.47.985.68 1.486.08.18.15.36.22.53 3.41-.43 6.8.26 7.14.33-.02-2.42-.88-4.64-2.31-6.38z"/>
  </svg>
);

// Instagram Icon
export const InstagramIcon = ({ className = "", size = 24 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
  </svg>
);

// LinkedIn Icon
export const LinkedInIcon = ({ className = "", size = 24 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

// GitHub Icon
export const GitHubIcon = ({ className = "", size = 24 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M12 0C5.374 0 0 5.373 0 12c0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23A11.509 11.509 0 0112 5.803c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576C20.566 21.797 24 17.3 24 12c0-6.627-5.373-12-12-12z"/>
  </svg>
);

// Medium Icon
export const MediumIcon = ({ className = "", size = 24 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M13.54 12a6.8 6.8 0 01-6.77 6.82A6.8 6.8 0 010 12a6.8 6.8 0 016.77-6.82A6.8 6.8 0 0113.54 12zM20.96 12c0 3.54-1.51 6.42-3.38 6.42-1.87 0-3.39-2.88-3.39-6.42s1.52-6.42 3.39-6.42 3.38 2.88 3.38 6.42M24 12c0 3.17-.53 5.75-1.19 5.75-.66 0-1.19-2.58-1.19-5.75s.53-5.75 1.19-5.75C23.47 6.25 24 8.83 24 12z"/>
  </svg>
);

// ============== NAVIGATION ICONS ==============

// Home Icon
export const HomeIcon = ({ className = "", size = 24 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
  </svg>
);

// Work/Portfolio Icon
export const WorkIcon = ({ className = "", size = 24 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z"/>
  </svg>
);

// About/Person Icon
export const AboutIcon = ({ className = "", size = 24 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
  </svg>
);

// Contact/Mail Icon
export const ContactIcon = ({ className = "", size = 24 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
  </svg>
);

// ============== SIDEBAR NAVIGATION ICONS (Figma Design) ==============

// Home Icon (outline style matching sidebar)
export const HomeOutlineIcon = ({ className = "", size = 32 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    stroke="#575861"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M5 14L16 5l11 9" />
    <path d="M8 12v14h16V12" />
    <path d="M13 26v-8h6v8" />
  </svg>
);

// Mail/Email Icon (outline style matching sidebar)
export const MailOutlineIcon = ({ className = "", size = 32 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    stroke="#575861"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="4" y="6" width="24" height="20" rx="2" />
    <path d="M4 10l12 8 12-8" />
  </svg>
);

// Suitcase/Briefcase Icon (outline style matching Figma)
export const SuitcaseIcon = ({ className = "", size = 32 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    stroke="#575861"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="5" y="10" width="22" height="16" rx="2" />
    <path d="M11 10V7a2 2 0 012-2h6a2 2 0 012 2v3" />
    <line x1="5" y1="18" x2="27" y2="18" />
  </svg>
);

// 3D Cube Icon (outline style matching Figma)
export const CubeIcon = ({ className = "", size = 32 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    stroke="#575861"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M16 4L4 10v12l12 6 12-6V10L16 4z" />
    <path d="M16 16L4 10" />
    <path d="M16 16l12-6" />
    <path d="M16 16v12" />
  </svg>
);

// Camera Aperture/Shutter Icon (outline style matching Figma)
export const ApertureIcon = ({ className = "", size = 32 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    stroke="#575861"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="16" cy="16" r="11" />
    <path d="M19.5 8.5L14 16" />
    <path d="M25 13L16 16" />
    <path d="M22.5 22L16 16" />
    <path d="M12.5 23.5L18 16" />
    <path d="M7 19L16 16" />
    <path d="M9.5 10L16 16" />
  </svg>
);

// Right Arrow Icon for "Read case study" links
export const ArrowRightIcon = ({ className = "", size = 16 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 8h10" />
    <path d="M9 4l4 4-4 4" />
  </svg>
);

// ============== ABOUT PAGE ICONS (Outline Style) ==============

// Building/Company Icon (for current work)
export const CompanyIcon = ({ className = "", size = 72 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 72 72"
    fill="none"
    stroke="#575861"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="8" y="16" width="24" height="48" rx="2" />
    <rect x="40" y="28" width="24" height="36" rx="2" />
    <path d="M14 24h6M14 32h6M14 40h6M14 48h6M14 56h6" />
    <path d="M46 36h6M46 44h6M46 52h6" />
    <path d="M32 40h8" />
  </svg>
);

// Briefcase Icon (for previous work)
export const WorkBriefcaseIcon = ({ className = "", size = 72 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 72 72"
    fill="none"
    stroke="#575861"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="8" y="20" width="56" height="40" rx="4" />
    <path d="M24 20V14a4 4 0 014-4h16a4 4 0 014 4v6" />
    <path d="M8 36h56" />
    <circle cx="36" cy="36" r="4" />
  </svg>
);

// Code/Developer Icon (for career start)
export const CodeIcon = ({ className = "", size = 72 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 72 72"
    fill="none"
    stroke="#575861"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M24 22L8 36l16 14" />
    <path d="M48 22l16 14-16 14" />
    <path d="M42 12L30 60" />
  </svg>
);

// Brain/Psychology Icon
export const BrainIcon = ({ className = "", size = 72 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 72 72"
    fill="none"
    stroke="#575861"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M36 64V36" />
    <path d="M20 36c-8 0-12-6-12-12s4-12 12-12c2 0 4 .5 6 1.5" />
    <path d="M52 36c8 0 12-6 12-12s-4-12-12-12c-2 0-4 .5-6 1.5" />
    <path d="M26 13.5C28 10 32 8 36 8s8 2 10 5.5" />
    <path d="M20 36c0 8 7 16 16 16s16-8 16-16" />
    <circle cx="28" cy="28" r="3" />
    <circle cx="44" cy="28" r="3" />
  </svg>
);

// Plant/Growth Icon (for social impact)
export const PlantIcon = ({ className = "", size = 72 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 72 72"
    fill="none"
    stroke="#575861"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M36 64V32" />
    <path d="M36 32c0-12 12-20 24-20-4 12-12 20-24 20" />
    <path d="M36 44c0-10-10-16-20-16 4 10 10 16 20 16" />
    <path d="M24 64h24" />
  </svg>
);

// Mentor/Teaching Icon
export const MentorTeachIcon = ({ className = "", size = 72 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 72 72"
    fill="none"
    stroke="#575861"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="24" cy="20" r="8" />
    <path d="M8 52v-4a16 16 0 0116-16h0" />
    <circle cx="48" cy="28" r="6" />
    <path d="M36 52v-4a12 12 0 0112-12h0" />
    <path d="M56 44l8-8-8-8" />
  </svg>
);

// Globe/World Icon (for passions)
export const WorldIcon = ({ className = "", size = 72 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 72 72"
    fill="none"
    stroke="#575861"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="36" cy="36" r="28" />
    <ellipse cx="36" cy="36" rx="12" ry="28" />
    <path d="M8 36h56" />
    <path d="M12 20h48" />
    <path d="M12 52h48" />
  </svg>
);

// Book/Learning Icon
export const BookOpenIcon = ({ className = "", size = 72 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 72 72"
    fill="none"
    stroke="#575861"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M36 16v44" />
    <path d="M36 16c-6-4-14-4-20 0v44c6-4 14-4 20 0" />
    <path d="M36 16c6-4 14-4 20 0v44c-6-4-14-4-20 0" />
  </svg>
);

// Football/Sports Icon
export const SportsIcon = ({ className = "", size = 72 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 72 72"
    fill="none"
    stroke="#575861"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="36" cy="36" r="28" />
    <path d="M36 8v12l10 8-4 12H30l-4-12 10-8V8" />
    <path d="M36 20l-10 8 4 12" />
    <path d="M36 20l10 8-4 12" />
    <path d="M26 28L12 32" />
    <path d="M46 28l14 4" />
    <path d="M30 40l-8 16" />
    <path d="M42 40l8 16" />
  </svg>
);

// Music/Headphones Icon
export const HeadphonesIcon = ({ className = "", size = 72 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 72 72"
    fill="none"
    stroke="#575861"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M8 40v-4a28 28 0 0156 0v4" />
    <rect x="8" y="40" width="12" height="20" rx="4" />
    <rect x="52" y="40" width="12" height="20" rx="4" />
  </svg>
);

// Game Controller Icon
export const GamepadIcon = ({ className = "", size = 72 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 72 72"
    fill="none"
    stroke="#575861"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M16 24h40a8 8 0 018 8v8a16 16 0 01-16 16H24a16 16 0 01-16-16v-8a8 8 0 018-8z" />
    <path d="M24 32v12" />
    <path d="M18 38h12" />
    <circle cx="48" cy="34" r="3" />
    <circle cx="54" cy="42" r="3" />
  </svg>
);

// Book/Reading Icon
export const ReadingIcon = ({ className = "", size = 72 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 72 72"
    fill="none"
    stroke="#575861"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 8h16a8 8 0 018 8v48a6 6 0 00-6-6H12V8z" />
    <path d="M60 8H44a8 8 0 00-8 8v48a6 6 0 016-6h18V8z" />
  </svg>
);

// Wave/Hand Icon (for greeting)
export const WaveIcon = ({ className = "", size = 72 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 72 72"
    fill="none"
    stroke="#575861"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M44 28V16a4 4 0 00-8 0v20" />
    <path d="M36 24V12a4 4 0 00-8 0v24" />
    <path d="M28 28V16a4 4 0 00-8 0v24l-4 4" />
    <path d="M52 36V24a4 4 0 00-8 0v12" />
    <path d="M52 36c8 8 8 20 0 28H28c-8-8-12-20-4-28" />
  </svg>
);

// ============== SIDE PANEL ICONS ==============

// Close/X Icon
export const CloseIcon = ({ className = "", size = 24 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M18 6L6 18" />
    <path d="M6 6l12 12" />
  </svg>
);

// Leaf/Agriculture Icon (for Cropperly)
export const LeafIcon = ({ className = "", size = 72 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 72 72"
    fill="none"
    stroke="#575861"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 60c0-24 12-44 36-48 0 24-12 44-36 48z" />
    <path d="M12 60c12-12 24-24 36-24" />
  </svg>
);

// Calendar/Meeting Icon (for MeetingMind)
export const CalendarIcon = ({ className = "", size = 72 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 72 72"
    fill="none"
    stroke="#575861"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="8" y="16" width="56" height="48" rx="4" />
    <path d="M8 28h56" />
    <path d="M24 8v16" />
    <path d="M48 8v16" />
    <circle cx="24" cy="42" r="4" />
    <circle cx="36" cy="42" r="4" />
    <circle cx="48" cy="42" r="4" />
  </svg>
);

// Piggy Bank/Savings Icon (for Susu)
export const PiggyBankIcon = ({ className = "", size = 72 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 72 72"
    fill="none"
    stroke="#575861"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <ellipse cx="36" cy="40" rx="24" ry="16" />
    <path d="M28 24c0-4 4-8 8-8s8 4 8 8" />
    <path d="M12 40v16" />
    <path d="M60 40v16" />
    <circle cx="48" cy="36" r="2" />
    <path d="M56 28l8-8" />
  </svg>
);

// Menu/Restaurant Icon (for Menu Board)
export const MenuBoardIcon = ({ className = "", size = 72 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 72 72"
    fill="none"
    stroke="#575861"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="12" y="8" width="48" height="56" rx="4" />
    <path d="M20 20h32" />
    <path d="M20 32h24" />
    <path d="M20 44h28" />
    <path d="M20 56h20" />
    <circle cx="52" cy="52" r="6" />
  </svg>
);

// House/Real Estate Icon (for Apolomiduu)
export const HouseIcon = ({ className = "", size = 72 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 72 72"
    fill="none"
    stroke="#575861"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M8 32L36 8l28 24" />
    <path d="M16 28v32h40V28" />
    <rect x="28" y="40" width="16" height="20" />
    <rect x="22" y="36" width="8" height="8" />
    <rect x="42" y="36" width="8" height="8" />
  </svg>
);

// Utensils/Food Icon (for Digital Menu)
export const UtensilsIcon = ({ className = "", size = 72 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 72 72"
    fill="none"
    stroke="#575861"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20 8v20c0 4-4 8-8 8v28" />
    <path d="M12 8v20c0 4 4 8 8 8" />
    <path d="M16 8v16" />
    <path d="M52 8v12a8 8 0 01-8 8h0a8 8 0 01-8-8V8" />
    <path d="M44 28v36" />
  </svg>
);

// Rocket/Startup Icon (for aspiring founder)
export const RocketIcon = ({ className = "", size = 72 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 72 72"
    fill="none"
    stroke="#575861"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M36 8c12 8 20 24 20 40H16c0-16 8-32 20-40z" />
    <circle cx="36" cy="32" r="6" />
    <path d="M16 48l-8 16 16-8" />
    <path d="M56 48l8 16-16-8" />
    <path d="M30 48v8a6 6 0 0012 0v-8" />
  </svg>
);